import React from 'react'
import aboutphoto  from "../images/About.jpeg"
function About() {
  return (
    <div>
         <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">
                          
                              <h1 style={{color:"#002d8e"}}><b>About Us – Maa Manasha College of Pharmacy</b></h1>
                              <h6 style={{color:"#008e85"}} className='justify'>Maa Manasha College of Pharmacy is committed to providing quality pharmacy education and developing skilled, knowledgeable, and responsible pharmacy professionals. Located at Kanralia, Balidanga-Faridpur, Kaliganj, Nadia, West Bengal – 741153, the college aims to create a supportive learning environment where students can build a strong foundation in pharmaceutical sciences and healthcare.</h6>
                              <p style={{color:"#008e8e"}} className='justify'>Approved by the <b>Pharmacy Council of India (PCI), New Delhi, </b>and affiliated with the State Medical Faculty of West Bengal, the institution focuses on academic excellence, practical training, professional ethics, and the development of essential skills required in the pharmaceutical sector.</p>
                              <p style={{color:"#008e72"}} className='justify'>Our goal is to empower students with the knowledge, confidence, and practical understanding needed to contribute to the healthcare industry and serve society responsibly. Through dedicated teaching, hands-on learning opportunities, and a student-focused approach, Maa Manasha College of Pharmacy strives to prepare the next generation of pharmacy professionals for a promising future.</p>
                              
                              </div>
                                   <div className="col-md-6 mt-3">
                            <img src={aboutphoto} className="card-img-top" alt="about" />

                                   </div>
                              </div>
                              </div>
                              </div>
    </div>
  )
}

export default About